'use client';

// Last-resort boundary for errors in the root layout itself. Must render its
// own <html>/<body>. Keeps the app from ever showing a blank white screen.

export default function GlobalError({ error, reset }) {
    return (
        <html>
            <body style={{ fontFamily: 'system-ui, sans-serif', background: '#ffffff', color: '#334155', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', margin: 0 }}>
                <div style={{ textAlign: 'center', maxWidth: 440, padding: 28 }}>
                    <div style={{ fontSize: 40, marginBottom: 10 }}>⚠️</div>
                    <h2 style={{ fontSize: 20, fontWeight: 800, margin: '0 0 8px' }}>The app hit an unexpected error</h2>
                    <p style={{ color: '#475569', fontSize: 14, margin: '0 0 16px' }}>Try reloading. If it keeps happening, restart the app.</p>
                    <button onClick={() => reset()} style={{ padding: '10px 20px', background: 'linear-gradient(90deg,#2563eb,#2563eb)', color: '#fff', border: 'none', borderRadius: 10, fontWeight: 800, fontSize: 13, cursor: 'pointer' }}>Reload</button>
                </div>
            </body>
        </html>
    );
}
